import type { JSX } from 'preact';
import cn from 'classnames';
import type { MediaGalleryItem } from '../../MediaGallery.tsx';
import styles from './ThumbnailItem.module.scss';
import PlayButton from '../PlayButton/PlayButton.tsx';
import ThumbnailImage from '../ThumbnailImage/ThumbnailImage.tsx';

export type ThumbnailItemProps = JSX.HTMLAttributes<HTMLLIElement> & {
  item: MediaGalleryItem;
  index: number;
  selected: boolean;
  loading?: HTMLImageElement['loading'];
  a11yLabel: string;
  variant: 'carousel' | 'fullscreen';
  class?: string;
  onThumbnailClick: (
    e: JSX.TargetedEvent<HTMLButtonElement>,
    index: number
  ) => void;
};
export default function ThumbnailItem({
  item,
  index,
  selected,
  loading = undefined,
  a11yLabel,
  class: className,
  variant,
  onThumbnailClick,
  ...props
}: ThumbnailItemProps) {
  /** Image thumbnail will be the image or the custom video poster (if set) */
  const thumbnailSrc = item.type === 'VIDEO' ? item.poster : item.url;

  return (
    <li
      class={cn(
        styles.thumb,
        {
          [styles.thumbCarousel]: variant === 'carousel',
          [styles.thumbFullscreen]: variant === 'fullscreen'
        },
        className
      )}
      {...props}
    >
      <button
        class={cn(styles.thumbButton, { [styles.thumbSelected]: selected })}
        type="button"
        onClick={(event) => onThumbnailClick(event, index)}
        tabIndex={0}
        aria-label={a11yLabel}
      >
        {thumbnailSrc && (
          <ThumbnailImage
            src={thumbnailSrc}
            alt={item.alt}
            loading={loading}
            width={64}
            height={64}
          />
        )}
        {/* only videos have a play button overlaid on top of the image */}
        {item.type === 'VIDEO' && <PlayButton />}
      </button>
    </li>
  );
}
